import { Icon, Stack } from "@fluentui/react";

import { PlanAppIconList } from "../PlanAppIconList";

import { PlanCardWithBadge } from "./PlanCardWithBadge";

import { StyledCard } from "@/modules/Offers/components/StyledCard";
import { Plan, PlanOfferItem } from "@/modules/Offers/types/PlansOffers.types";

const PLANS_WITH_ICONS = ["Vivo", "Claro", "TIM"];

type CardPlanProps = {
  plan: PlanOfferItem;
  selectedPlan?: Plan;
  selectedCarrier?: PlanOfferItem;
  setSelectedPlan?: (plan: Plan) => void;
  setSelectedCarrier?: (carrier: PlanOfferItem) => void;
  openModal: () => void;
  formType: "ENERGY" | "LINES" | "TAGS";
};

export function CardPlan({
  plan,
  selectedPlan,
  selectedCarrier,
  setSelectedPlan,
  setSelectedCarrier,
  openModal,
  formType
}: CardPlanProps): JSX.Element {
  return (
    <StyledCard>
      <img
        src={plan.logo}
        alt={plan.name}
        style={{ margin: "20px", height: 30 }}
      />

      <Stack tokens={{ childrenGap: 15 }}>
        {PLANS_WITH_ICONS.includes(plan.name) && (
          <>
            <Stack horizontal verticalAlign="center">
              <Icon
                iconName="Phone"
                style={{
                  fontSize: 20,
                  marginRight: 15
                }}
              />
              <span className="ms-fontSize-18">Ligações ilimitadas</span>
            </Stack>
            <Stack horizontal verticalAlign="center">
              <Icon
                iconName="Globe"
                style={{
                  fontSize: 20,
                  marginRight: 15
                }}
              />
              <span className="ms-fontSize-18">Pacotes de dados</span>
            </Stack>
          </>
        )}
      </Stack>
      <PlanCardWithBadge
        plan={plan}
        selectedPlan={selectedPlan}
        selectedCarrier={selectedCarrier}
        setSelectedPlan={setSelectedPlan}
        setSelectedCarrier={setSelectedCarrier}
        openModal={openModal}
        formType={formType}
      />
      {plan.plans[0]?.freeDataApps?.length > 0 && (
        <PlanAppIconList
          appIcon={plan.plans[0].freeDataApps}
          appInfo={plan.plans[0].appsInfos}
          appTitle="Apps Ilimitados"
          verticalAlign="end"
          height="100%"
        />
      )}
    </StyledCard>
  );
}
